var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-marker",style:({ zIndex: Number(_vm.id === _vm.activeId) })},[_c(_vm.iconComponent,{tag:"component",attrs:{"inverse":_vm.isActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }